import {
  View,
  Text,
  KeyboardAvoidingView,
  Platform,
  TouchableWithoutFeedback,
  Keyboard,
  TextInput,
} from "react-native";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import {
  changeHeaderColor,
  hideBottomNavigation,
  showBackButton,
  showBackButtonWithFunction,
  showBottomNavigation,
} from "../../redux/header/headerAction";
import {
  danger,
  lightBlue,
  lighterBlue,
  orange,
  primary,
  textSecondary,
  white,
} from "../../colors";
import SelectChildrenMini from "../../components/custom/SelectChildrenMini";
import DoctorChatDetail from "../../components/consultation/DoctorChatDetail";
import ChatInput from "../../components/consultation/ChatInput";
import VoiceMessage from "../../components/consultation/chatMessage/VoiceMessage";
import TextMessage from "../../components/consultation/chatMessage/TextMessage";
import ImageMessage from "../../components/consultation/chatMessage/ImageMessage";
import { FlatList } from "react-native-gesture-handler";
import detailConsultationUser from "../../api/consultation/detailConsultationUser";
import getChatMessages from "../../api/consultation/getChatMessages";
import { io } from "socket.io-client";
import getToken from "../../api/token";
import getMessages from "../../api/support/getMessages";
import SupportChatInput from "../../components/consultation/SupportChatInput";
import MyText from "../../components/custom/MyText";
import { AntDesign } from "@expo/vector-icons";
import translate from "../../functions/translate";
import SupportTimeItem from "../../components/custom/SupportTimeItem";
import responseDayList from "../../api/consultation/responseDayList";
import MyButton from "../../components/custom/MyButton";
import setResponseDay from "../../api/consultation/setResponseDay";
import MyInputWithLabel from "../../components/custom/MyInputWithLabel";
import maxConsultation from "../../api/consultation/maxConsultation";
import setMaxConsultation from "../../api/consultation/setMaxConsultation";
import { Entypo } from "@expo/vector-icons";
import Fade from "../../components/animation/Fade";
import faqList from "../../api/consultation/faqList";
import deleteFaq from "../../api/consultation/deleteFaq";
import editFaq from "../../api/consultation/editFaq";
import addFaq from "../../api/consultation/addFaq";
import setHiMessage from "../../api/consultation/setHiMessage";
import Toast from "react-native-toast-message";
import getHiMessage from "../../api/consultation/getHiMessage";

export default function ChatSettings({ route }) {
  const scrollViewRef = useRef(null);
  const [info, setInfo] = useState({
    maxConsultation: "",
  });
  const [hiMessage, setHiMessageState] = useState("");
  useEffect(() => {
    getHiMessage().then(({ data }) => {

      if (data.status === 200) {
        setHiMessageState(data.data);
      }
    });
    maxConsultation().then(({ data }) => {
      if (data.status === 200) {
        setInfo((prev) => {
          let newObj = prev;
          newObj["maxConsultation"] = data.data;
          return { ...newObj };
        });
      }
    });
  }, []);
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const isFocused = useIsFocused();
  const dayList = [
    "شنبه",
    "یک شنبه",
    "دو شنبه",
    "سه شنبه",
    "چهار شنبه",
    "پنج شنبه",
    "جمعه",
  ];

  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor("#fcfcfc"));
      dispatch(showBackButtonWithFunction(() => navigation.goBack()));
    }
    return () => {};
  }, [isFocused]);

  const [inputMode, setInputMode] = useState("hidden");
  const [inputPlace, setInputPlace] = useState(0);

  const [doctorDays, setDoctorDays] = useState({});
  const [newDoctorDays, setNewDoctorDays] = useState({});
  const [input, setInput] = useState({
    shortcut: "",
    text: "",
    id: 0,
  });
  const [shortcutList, setShortcutList] = useState([]);

  useEffect(() => {
    getFaqList();
  }, []);
  const getFaqList = () => {
    faqList().then(({ data }) => {

      if (data.status === 200) {
        setShortcutList(data.data);
      }
    });
  };
  const deleteShortcut = (id) => {
    deleteFaq(id).then((response) => {
      getFaqList();
    });
  };

  const editShortcut = (text, shortcut, id) => {
    setInput({ text: text, shortcut: shortcut, id: id });
    setInputMode("edit");

    scrollViewRef.current.scrollToPosition(0, inputPlace, true);
  };

  const saveChanges = () => {
    setHiMessage(hiMessage.length === 0 ? null : hiMessage).then((response) => {
      Toast.show({
        type: "success",
        text1: "تغییرات با موفقیت ذخیره شد",
      });
    });
  };

  const inputSectionButton = () => {
    if (inputMode === "hidden") {
      setInputMode("new");
    } else if (inputMode === "edit") {
      editFaq(input.text, input.shortcut, input.id).then((response) => {
        getFaqList();
      });
      setInputMode("hidden");
      setInput({ text: "", shortcut: "", id: 0 });
    } else if (inputMode === "new") {
      addFaq(input.text, input.shortcut).then((response) => {
        getFaqList();
        setTimeout(() => scrollViewRef.current.scrollToEnd(), 1000);
        Toast.show({
          type: "success",
          text1: "با موفقیت افزوده شد",
        });
      });
      setInputMode("hidden");
      setInput({ text: "", shortcut: "", id: 0 });
    }
  };

  return (
    <View style={{ flex: 1 }}>
      <KeyboardAwareScrollView
        ref={scrollViewRef}
        enableOnAndroid
        extraHeight={100}
      >
        <View style={{}}>
          <View
            style={{
              backgroundColor: "#fff",
              width: "100%",
              alignItems: "center",

              paddingBottom: Platform.OS !== "web" ? 30 : 0,
            }}
          >
            <View
              style={{
                width: "95%",
                backgroundColor: "#eeeeee",
                padding: 10,
                marginVertical: 10,
                borderRadius: 5,
              }}
            >
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <View>
                  <Entypo name="chat" size={35} color={"#894378"} />
                </View>
                <MyText style={{ marginHorizontal: 10, fontSize: 18 }}>
                  تنظیمات چت
                </MyText>
              </View>
            </View>
            <View style={{ flex: 1, width: "100%", alignItems: "center" }}>
              <View
                style={{
                  width: "95%",
                  padding: 10,
                  borderRadius: 10,
                  backgroundColor: "#fafafa",
                  borderWidth: 1,
                  borderColor: "#eeeeee",
                }}
              >
                <View>
                  <MyText style={{ fontSize: 16 }}>متن پیشفرض شروع چت</MyText>
                  <MyText style={{ fontSize: 11 }}>
                    پس از این که کاربر چت را شروع کرد این پیام به صورت خودکار
                    برای او ارسال میشود
                  </MyText>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    marginVertical: 20,
                    alignItems: "center",
                  }}
                >
                  <View
                    style={{
                      width: "100%",

                      alignItems: "center",
                    }}
                  >
                    <TextInput
                      value={hiMessage}
                      multiline={true}
                      onChangeText={(text) => {
                        setHiMessageState(text);
                      }}
                      style={{
                        borderWidth: 1,
                        borderColor: primary,
                        width: "90%",
                        borderRadius: 5,
                        height: 100,
                        padding: 5,
                      }}
                    />
                  </View>
                </View>
                <View
                  style={{
                    flex: 1,
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  <MyButton
                    style={{}}
                    text="ذخیره تغییرات"
                    onPress={saveChanges}
                  />
                </View>
              </View>
            </View>
            <View
              style={{
                marginTop: 20,
                width: "100%",
                alignItems: "center",
              }}
            >
              <View
                style={{
                  width: "95%",
                  padding: 10,
                  borderRadius: 10,
                  backgroundColor: "#fafafa",
                  borderWidth: 1,
                  borderColor: "#eeeeee",
                }}
              >
                <View>
                  <MyText style={{ fontSize: 16 }}>
                    میانبر متون پر تکرار چت
                  </MyText>
                  <MyText style={{ fontSize: 11 }}>
                    پیام هایی که پر تکرار هستند را در این قسمت تعریف کنید تا در
                    صفحه چت بدون نیاز به تایپ کردن آن ها از این متون استفاده
                    کنید
                  </MyText>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    marginVertical: 20,
                    alignItems: "center",
                  }}
                  onLayout={(event) => {
                    let { y } = event.nativeEvent.layout;

                    setInputPlace(y + 40);
                  }}
                >
                  <Fade isShown={inputMode !== "hidden"}>
                    <View
                      style={{
                        width: "100%",

                        alignItems: "center",
                      }}
                    >
                      <View style={{ width: "90%", marginBottom: 5 }}>
                        <MyText>کلید میانبر پیام</MyText>
                      </View>
                      <MyInputWithLabel
                        name={"shortcut"}
                        value={input.shortcut}
                        setInput={setInput}
                      />

                      <View style={{ width: "90%", marginBottom: 5 }}>
                        <MyText>متن پیام</MyText>
                      </View>

                      <TextInput
                        onChangeText={(text) => {
                          setInput((prev) => ({
                            ...prev,
                            text: text,
                          }));
                        }}
                        value={input.text}
                        multiline={true}
                        style={{
                          borderWidth: 1,
                          borderColor: primary,
                          width: "90%",
                          borderRadius: 5,
                          height: 100,
                          padding: 5,
                        }}
                      />
                    </View>
                  </Fade>
                </View>
                <View
                  style={{
                    width: "100%",
                    alignItems: "center",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  <MyButton
                    style={{ backgroundColor: orange }}
                    text={
                      inputMode === "hidden"
                        ? "افزودن میانبر جدید"
                        : inputMode === "edit"
                        ? "ذخیره تغییرات"
                        : "افزودن میانبر"
                    }
                    onPress={inputSectionButton}
                  />
                  {inputMode !== "hidden" && (
                    <MyButton
                      style={{
                        borderColor: orange,
                        borderWidth: 1,
                        backgroundColor: "#fefefe",
                        marginHorizontal: 5,
                      }}
                      textStyle={{ color: orange }}
                      text={"لغو"}
                      onPress={() => {
                        setInputMode("hidden");
                        setInput({
                          shortcut: "",
                          text: "",
                          id: 0,
                        });
                      }}
                    />
                  )}
                </View>
                <View
                  style={{
                    width: "100%",
                    marginVertical: 20,
                  }}
                >
                  <MyText>لیست میانبر ها</MyText>
                  {shortcutList.map((shortcut, index) => (
                    <View style={{ marginTop: 5 }} key={index}>
                      <View
                        style={{
                          backgroundColor: "#ffffff",
                          padding: 10,
                          borderWidth: 1,
                          borderRadius: 10,
                          borderColor: primary,
                        }}
                      >
                        <View
                          style={{ flexDirection: "row", alignItems: "center" }}
                        >
                          <MyText style={{ fontSize: 16, color: orange }}>
                            کلید میانبر
                          </MyText>
                          <MyText style={{ marginHorizontal: 5 }}>
                            {shortcut.shortCut !== undefined &&
                            shortcut.shortCut !== null
                              ? shortcut.shortCut
                              : "- ندارد -"}
                          </MyText>
                        </View>
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            marginTop: 5,
                          }}
                        >
                          <MyText style={{ fontSize: 16, color: orange }}>
                            متن
                          </MyText>
                          <MyText style={{ marginHorizontal: 5 }}>
                            {shortcut.textFa !== undefined &&
                            shortcut.textFa !== null
                              ? shortcut.textFa
                              : "- ندارد -"}
                          </MyText>
                        </View>
                        <View
                          style={{
                            flex: 1,
                            flexDirection: "row",
                            marginTop: 20,
                          }}
                        >
                          <View style={{ flex: 1 }}></View>
                          <MyButton
                            style={{
                              marginHorizontal: 5,
                              backgroundColor: lightBlue,
                            }}
                            textStyle={{ color: "gray" }}
                            text="ویرایش"
                            onPress={() =>
                              editShortcut(
                                shortcut.textFa,
                                shortcut.shortCut,
                                shortcut.id
                              )
                            }
                          />
                          <MyButton
                            onPress={() => deleteShortcut(shortcut.id)}
                            style={{ backgroundColor: danger }}
                            text="حذف"
                          />
                        </View>
                      </View>
                    </View>
                  ))}
                </View>
              </View>
            </View>
          </View>
        </View>
        <View style={{ height: 100 }}></View>
      </KeyboardAwareScrollView>
    </View>
  );
}
